export default function getAdriaticStyles() {
    return [
        {
            featureType: 'poi.business',
            stylers: [{ visibility: 'off' }],
        },
        {
            featureType: 'administrative.country',
            elementType: 'geometry.stroke',
            stylers: [
                { color: '#86a49d' },
                { weight: 2 },
            ],
        },
        {
            featureType: 'landscape.man_made',
            elementType: 'geometry.fill',
            stylers: [{ color: '#f2ede3' }],
        },
        {
            featureType: 'landscape.natural',
            elementType: 'geometry.fill',
            stylers: [{ color: '#f2f2f2' }],
        },
        {
            featureType: 'landscape.natural.terrain',
            elementType: 'geometry.fill',
            stylers: [{ color: '#d1e7c7' }],
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
                { color: '#fde0a8' },
                { weight: 2 },
            ],
        },
        {
            featureType: 'road.highway.controlled_access',
            elementType: 'geometry.fill',
            stylers: [
                { color: '#ff9966' },
                { weight: 1 },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'geometry.fill',
            stylers: [{ color: '#ffffff' }],
        },
        {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [{ color: '#d1e7ff' }],
        },
    ];
}
